(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/disabled-team-result/assets/javascripts/disabled-team-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/disabled-team-result/assets/javascripts/disabled-team-result.js');
"use strict";

const {
  ReactIcon
} = svs.ui;
const DisabledTeamResult = () => React.createElement("div", {
  className: "disabled-team-result"
}, React.createElement(ReactIcon, {
  icon: "information",
  size: "600"
}), React.createElement("h3", {
  className: "f-medium"
}, "Tekniskt fel"), React.createElement("span", null, "Vi kan inte visa lagstatistik p\xE5 grund av tekniskt fel."));
setGlobal('svs.components.marketplaceCompetition.disabledTeamResult.DisabledTeamResult', DisabledTeamResult);

 })(window);